module.exports = "<!--\r\n<div class=\"loader\"></div>-->\r\n<img src=\"../../../assets/images/spinner-loader.svg\" alt=\"Loading...\">\r\n"